export default "__VITE_ASSET__leEQeSYd__"